import React from 'react';

import '../assets/css/CategoryCard.scss';
import history from '../history';

import {getParams} from '../store/params/reducer';
import updateParams from '../store/params/action';
import {connect} from 'react-redux';

const CategoryCard = ({
  categoryData,
  type,
  params,
  updateParams
}) => {

  const redirectToAndStorage = (route, category) => {
    if(type==="special"){
      let obj = {
        ...params,
        specialCategories: [category.id],
      };
      obj.filters.[category.id] = true;
      updateParams(obj);
      history.push('search');
      return;
    }

    updateParams({
      ...params,
      categories: [category.name],
      selectedCategory: [category.name]
    });
    history.push(route);
  };

  return (
    <button
      type="button"
      className="btn btn-lg btn-block btn-category-card"
      onClick={() => redirectToAndStorage('search', categoryData)}
      >
      {categoryData.name}
    </button>
  );
};

const mapStateToProps = state => {
  return {
    params: getParams(state)
  };
};

export default connect(mapStateToProps, {updateParams})(CategoryCard);
